import ChoiceModal from './ChoiceModal'

export default ChoiceModal
